import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Grid, Typography } from "@mui/material";
// import { getTaskCreateClients } from "api/services/clients/clients";
// import { updateEvent } from "api/services/events";
// import { getTask, getTasks } from "api/services/tasks/tasks";
import DrawerWrapper from "components/DrawerWrapper";
import FormTime from "components/FormFields/FomTime";
import FormAutoComplete from "components/FormFields/FormAutocomplete";
import FormCheckbox from "components/FormFields/FormCheckbox";
import FormDate from "components/FormFields/FormDate";
import FormInput from "components/FormFields/FormInput";
import FormSelect from "components/FormFields/FormSelect";
import Loader from "components/Loader";
import LoadingButton from "components/LoadingButton";
import { snack } from "components/toast";
import moment from "moment";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { ResType } from "types";
import { getTitle } from "utils";
import { Reminders } from "data/constants";
import {
  addCalendarEventDefaultValues,
  AddCalendarEventSchema,
} from "./addCalendarEvent";
import ReactQuill from "lib/react-quill";
import FormRadio from "components/FormFields/FormRadio";
import FormClientGroupAutoComplete from "components/FormFields/FormClientAutocomplete";
import { getTasks } from "api/services/tasks";
import { updateRequestEvent } from "api/services/events";

function EditEvent({ data, open, setOpen }) {
  const queryClient = useQueryClient();
  // const [taskMembers, setTaskMembers] = useState<any[]>([]);

  const { control, watch, handleSubmit, reset, setValue } = useForm({
    defaultValues: addCalendarEventDefaultValues,
    mode: "onChange",
    resolver: yupResolver(AddCalendarEventSchema()),
  });

  useEffect(() => {
    if (!data) return;
    console.log("data", data)
    reset({
      ...data,
      client: data?.client
        ? {
          label: data?.client?.displayName,
          value: data?.client?.id,
          type: null,
        }
        : data?.clientGroup ? {
          label: data?.clientGroup?.displayName,
          value: data?.clientGroup?.id,
          type: data?.clientGroup?.type,
        } : null,
      task: data?.task
        ? {
          label: data?.task?.name,
          value: data?.task?.id,
        }
        : null,
      members:
        data?.members?.map((member: any) => ({
          label: member.fullName,
          value: member.id,
        })) || [],
      reminderCheck: Boolean(data.reminder),
      reminder: data.reminder || "",
    });
  }, [data, reset, open]);

  const { data: tasks, isLoading: tasksLoading }: ResType = useQuery(
    ["tasks", { client: localStorage.getItem("clientId") || "" }],
    getTasks,
    {
      enabled: open,
    }
  );

  let { mutate, isLoading: createLoading } = useMutation(updateRequestEvent, {
    onSuccess: () => {
      if (watch("type") === "TASK") {
        snack.success("Task Event Updated")
      } else {
        snack.success("General Event Updated")
      }
      queryClient.invalidateQueries("requested-events");
      setOpen(false);
    },
    onError: (err: any) => {
      snack.error(err.response.data.message);
    },
  });

  const onSubmit = (result: any) => {
    const { reminderCheck, ...apiData } = result;
    apiData.clientId = localStorage.getItem("clientId");
    apiData.task = apiData?.task?.value;
    apiData.reminder = reminderCheck ? apiData.reminder : null;
    apiData.date = moment(apiData.date).format("YYYY-MM-DD");
    mutate({
      id: data?.id,
      data: { ...apiData },
    });
  };

  if (tasksLoading) return <Loader />

  return (
    <DrawerWrapper open={open} setOpen={setOpen} title="Update an Event Request">
      {tasksLoading ? (
        <Loader />
      ) : (
        <form onSubmit={handleSubmit(onSubmit)}>
          {watch("type") === "TASK" && (
            <>
              <Box mt={2}>
                <FormAutoComplete
                  control={control}
                  label="Task"
                  name="task"
                  options={tasks?.data?.[0]?.map((item: any) => ({
                    label: item.name,
                    value: item.id,
                  })) || []}
                />
              </Box>
            </>
          )}
          <Box mt={2}>
            <FormInput
              name="title"
              control={control}
              label="Event Title*"
              inputProps={{ maxLength: 50 }}
            />
          </Box>
          <Box mt={2}>
            <FormInput
              name="location"
              control={control}
              label="Location*"
              inputProps={{ maxLength: 50 }}
            />
          </Box>
          <Box mt={2}>
            <FormDate name="date" control={control} label="Date*" />
          </Box>
          <Box mt={2}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <FormTime name="startTime" control={control} label="Start Time*" />
              </Grid>
              <Grid item xs={6}>
                <FormTime name="endTime" control={control} label="End Time*" />
              </Grid>
            </Grid>
          </Box>
          {/* <Box mt={2}>
            <FormCheckbox name="reminderCheck" control={control} label="Set Reminder" />
          </Box>
          {watch("reminderCheck") && (
            <Box mt={2}>
              <FormSelect
                name="reminder"
                control={control}
                label="Reminder"
                options={Object.values(Reminders).map((item) => ({
                  label: getTitle(item),
                  value: item,
                }))}
              />
            </Box>
          )} */}

          <Box mt={2}>
            <Typography color="primary" variant="h6" sx={{ mb: 1 }}>
              Event Description
            </Typography>
            <Controller
              control={control}
              name="notes"
              render={({ field: { value, onChange } }) => (
                <ReactQuill
                  value={value || ""}
                  onChange={(v: any) => {
                    onChange(v);
                  }}
                  modules={{
                    clipboard: {
                      matchVisual: false,
                    },
                  }}
                  id="overview"
                />
              )}
            />
          </Box>

          <Box mt={3}>
            <LoadingButton
              loading={false}
              disabled={false}
              type="submit"
              fullWidth
              loadingColor="white"
              title="Update Event"
              color="secondary"
            />
          </Box>
        </form>
      )}
    </DrawerWrapper>
  );
}

export default EditEvent;
